import * as auth from "./auth";
import * as signalr from "@microsoft/signalr";
import store from "../store";
import { LOG_LEVEL } from "./consts";

const DEBUG = process.env.VUE_APP_DEBUG || config.VUE_APP_DEBUG;
const SIGNALR_HUB_NAME = `${process.env.VUE_APP_API_BASE_URL || config.VUE_APP_API_BASE_URL}notificationHub`;
export const MESSAGES = {
  VersionUpdate: "New version avaliable. Please refresh page",
};
export const SIGNALR_SERVICE_MESSAGES = {
  VersionUpdate: "APPLICATION_VERSION_UPDATE",
};

export const NOTIFICATION_TYPE = {
  VersionUpdate: "update-version",
};

export const signalRConnection = (function () {
  var connection = new signalr.HubConnectionBuilder()
    .withUrl(SIGNALR_HUB_NAME, { accessTokenFactory: () => auth.getToken() })
    .withAutomaticReconnect({
      nextRetryDelayInMilliseconds: (retryContext) => {
        if (retryContext.elapsedMilliseconds < 10 * 60000) {
          // If we've been reconnecting for less than 10 minutes so far,
          // wait between 0 and 10 seconds before the next reconnect attempt.
          return Math.random() * 10000;
        } else {
          // If we've been reconnecting for more than 60 seconds so far, stop reconnecting.
          return null;
        }
      },
    })
    .configureLogging(signalr.LogLevel.Warning) // signalr.LogLevel.Warning, signalr.LogLevel.Information
    .build();
  return connection;
})();

const messageIdStore = {
  idStore: [],
  checkMessageProcessed(messageId) {
    return this.idStore.includes(messageId);
  },
  addProcessedMessage(messageId) {
    this.idStore.push(messageId);
    setTimeout(() => {
      this.idStore.splice(this.idStore.indexOf(messageId), 1);
    }, 60000);
  },
};

// Message processing

let loading = false;
let runAfter = [];

export async function addUserNotification(mi) {
  await store.dispatch('notifications/addNotification', mi).then(async () => {
  })
}

function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
function unreadInfoFind(x, ui) {
  return (x.Type && ui.Type && x.Type === ui.Type)
    || (x.PeriodId && ui.PeriodId && x.PeriodId === ui.PeriodId)
}

export async function updateNotification(mi) {
  let notes = store.getters["notifications/notificationMessages"];
  let note = notes.find(a => a.messageData.Record.Id == mi.messageData.Record.Id && a.messageData.Record.Title == mi.messageData.Record.Title);

  if (note) {
    note.messageData.Record = mi.messageData.Record;
    note.messageData.Result = mi.messageData.Result;
    note.messageData.NotificationType = mi.messageData.NotificationType;
    if (note.messageData.PeriodId && note.messageData.PeriodName) {
      note.messageData.PeriodId = mi.messageData.PeriodId;
      note.messageData.PeriodName = mi.messageData.PeriodName;
    }
    if (mi.messageData.UnreadInfo) {
      let c = 0;
      if (Array.isArray(note.messageData.UnreadInfo) && note.messageData.UnreadInfo.length > 0) {
        let existsPeriods = note.messageData.UnreadInfo.map(x => x.PeriodId);
        let newPeriods = mi.messageData.UnreadInfo.filter(x => !existsPeriods.includes(x.PeriodId));
        note.messageData.UnreadInfo = note.messageData.UnreadInfo.concat(newPeriods);
        note.messageData.UnreadInfo.forEach(ui => {
          let deletedUi2 = null;
          if (Array.isArray(mi.messageData.DeletedInfo))
            deletedUi2 = mi.messageData.DeletedInfo.find(x => unreadInfoFind(x, ui));

          let ui2 = mi.messageData.UnreadInfo.find(x => unreadInfoFind(x, ui));

          if (ui2) {
            ui.Status = ui2.Status;
            ui.Ids = ui2.Ids.concat(ui.Ids).filter(onlyUnique);
            if (deletedUi2) {
              ui.Ids = ui.Ids.filter(x => !deletedUi2.Ids.includes(x));
            }
            if (ui.Aditional && ui2.Aditional) {
              const exists = ui.Aditional.map(a => a.Id);
              ui.Aditional = ui.Aditional
                .map(a => Object.assign(a, ui2.Aditional.find(a2 => a2.Id === a.Id)))
                .concat(ui2.Aditional.filter(a2 => !exists.includes(a2.Id)))
            }
          }
          c += ui.Ids.length;
        });
        // mi.messageData.UnreadInfo.forEach(ui => {
        //   var ui2 = note.messageData.UnreadInfo.find(x => x.Type === ui.Type);
        //   if (ui2) return;
        //   note.messageData.UnreadInfo.push(ui);
        //   c += ui.Ids.length;
        // });
      } else if (note.messageData.UnreadInfo?.Ids) {
        note.messageData.UnreadInfo.Ids = mi.messageData.UnreadInfo.Ids.concat(note.messageData.UnreadInfo.Ids).filter(onlyUnique);
        c = note.messageData.UnreadInfo.Ids.length;
      }
      note.messageData.UnreadCount = c;
      note.title = mi.title.replace("{counter}", note.messageData.UnreadCount);
    } else {
      note.title = mi.title;
    }
    note.logLevel = mi.logLevel;
    note.message = mi.message;
    note.messageId = mi.messageId;
    note.isClosed = false;
    note.date = new Date();

    return await store.dispatch('notifications/updateNotification', note);
  } else {
    if (mi.messageData.UnreadInfo) {
      mi.titleTemplate = mi.title;
      if (mi.messageData.UnreadCount) {
        mi.title = mi.title.replace("{counter}", mi.messageData.UnreadCount);
      }
    }
    return await addUserNotification(mi);
  }
}

export function handleApiChange(mi) {
  addUserNotification({
    logLevel: mi.logLevel,
    title: MESSAGES.VersionUpdate,
    type: NOTIFICATION_TYPE.VersionUpdate,
  });
}

async function processMessage(mi) {
  if (DEBUG)
    console.log("ReceiveNotification:", mi);

  if (mi.messageId && messageIdStore.checkMessageProcessed(mi.messageId)) {
    console.log(`message '${mi.messageId}' was skipped due to it's already processed`);
    return;
  } else if (mi.messageId) {
    messageIdStore.addProcessedMessage(mi.messageId);
  }
  mi.logLevel = getLogLevel(mi.level);
  var serviceMessageKey = Object.keys(SIGNALR_SERVICE_MESSAGES).find(
    (m) => SIGNALR_SERVICE_MESSAGES[m] == mi.message
  );
  if (serviceMessageKey) {
    if (processingType !== "silence") {
      let tmpMi = { ...mi };
      tmpMi.message = MESSAGES[serviceMessageKey];
      await addUserNotification(tmpMi);
    }

    if (mi.message == SIGNALR_SERVICE_MESSAGES.VersionUpdate) {
      handleApiChange(mi);
    }
  } else {
    if (mi.messageData && mi.messageData.Record.Id) {
      await updateNotification(mi)
    } else {
      await addUserNotification(mi);
    }
  }

}

// signalR handler
export function notificationsInit() {
  let loadPromise = store.dispatch('notifications/load');
  signalRConnection.on(
    "ReceiveNotification",
    function (processingType, messageId, level, message, messageData, notificationId, title, typeTarget, createDate) {
      processMessage({ processingType, messageId, level, message, messageData, notificationId, title, typeTarget, createDate });
    }
  );

  signalRConnection.on("ReceiveServiceSignal", function (type, params) {
    console.log("Service signal: " + type + " " + params);
  });

  window.onbeforeunload = function () {
    signalRConnection.stop();
  };

  let hubUrl = process.env.VUE_APP_SIGNALR_URL || config.VUE_APP_SIGNALR_URL;
  let origin = signalRConnection.connection._startTransport;
  signalRConnection.connection._startTransport = (url, transferFormat) => {
    let signalRUrl = hubUrl ? hubUrl + 'notificationHub' : url;
      
    let responce = origin.call(signalRConnection.connection, signalRUrl, transferFormat);
    
    return responce;
  };

  signalRConnection.start().catch((err) => {
    if (DEBUG) console.error(err.toString());
  });

  return loadPromise;
}
function getLogLevel(logLevel) {
  if (logLevel === 0) return LOG_LEVEL.Trace;
  else if (logLevel === 1) return LOG_LEVEL.Debug;
  else if (logLevel === 2) return LOG_LEVEL.Information;
  else if (logLevel === 3) return LOG_LEVEL.Warning;
  else if (logLevel === 4) return LOG_LEVEL.Error;
  else if (logLevel === 5) return LOG_LEVEL.Critical;
  else if (logLevel === 6) return LOG_LEVEL.None;
  return LOG_LEVEL.Information;
}
